import { format } from 'date-fns'
import { Link } from 'react-router-dom'


const data = [
  {
  id: '1',
  customer_name: 'Fernando Cabello',
  customer_id: '726',
  date: '2022-05-17T03:24:00',
  title: 'Lorte Ipsum ius',
},
{
  id: '1',
  customer_name: 'Fernando Cabello',
  customer_id: '726',
  date: '2022-05-17T03:24:00',
  title: 'Lorte Ipsum ius',

},
{
  id: '1',
  customer_name: 'Fernando Cabello',
  customer_id: '726',
  date: '2022-05-17T03:24:00',
  title: 'Lorte Ipsum ius',

},
{
  id: '1',
  customer_name: 'Fernando Cabello',
  customer_id: '726',
  date: '2022-05-17T03:24:00',
  title: 'Lorte Ipsum ius',

},
]


export default function MessagesMainBox() {
  return (
	<div className="bg-white p-4 rounded-lg shadow border border-gray-200 flex-auto">
			 <h2 className="text-xl text-gray-800 font-semibold mb-4">Mensajes</h2>
			 	<div className="overflow-x-auto">
			 	<table className="w-full text-left text-gray-700">
				 <thead className="text-xs text-gray-700 uppercase bg-gray-50">
						<tr>

							<th scope="col" className="py-3 px-2">Nombre</th>
							<th scope="col" className="py-3 px-2">Socio</th>
							<th scope="col" className="py-3 px-2">Fecha</th>
             				<th scope="col" className="py-3 px-2">Titulo</th>
							<th scope="col" className="py-3 px-2">Actions</th>
					

						</tr>
					</thead>
					<tbody>
						{data.map((order) => (
							<tr key={order.id} className="border-b odd:bg-white even:bg-gray-50 hover:bg-gray-100">
								<td className="py-2 px-3">
									<Link to="/customers">{order.customer_name}</Link>
								</td>
								<td className="py-2 px-3">
									<Link to={`/customer/${order.customer_id}`}>{order.customer_id}</Link>
								</td>
								<td>{format(new Date(order.date), 'dd MMM yyyy hh:mm')}</td>
								<td className="py-2 px-3">
								<Link to={`/customer/${order.title}`}>{order.title}</Link>
								</td>
								<td className="py-2 px-3">
									<button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
										Ver
									</button>
								</td>
								<td className="py-2 px-3">
									<button class="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
										Borrar
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
  )
}
